import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Navigate, Route, Routes} from 'react-router-dom';

import {ErrorBoundary} from '@sentry/react';
import {ErrorPage} from 'src/modules/error-page/error-page.components';
import {clearData, clearRanges} from 'src/modules/profile/account/tabs/admin-account-api-v2/views/controllers/setup/services/actions';

import {API_TABS} from './contants';
import {TabsStructure} from './views';
import {AlertsController} from './views/controllers/alerts';
import {CallsTab} from './views/controllers/calls';
import {LimitsTab} from './views/controllers/limits';
import {PricingController} from './views/controllers/pricing';
import {ReleaseNotesController} from './views/controllers/release-notes';
import {SetupController} from './views/controllers/setup';

type Props = {
    accountId: number,
};

export const MicroApp = ({accountId}: Props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(clearData());
            dispatch(clearRanges());
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ErrorBoundary fallback={<ErrorPage title="API Page is unavailable" subtitle="Please try again later."/>}>
            <Routes>
                <Route
                    path={`/${API_TABS.SETUP.name}`}
                    element={(
                        <TabsStructure accountId={accountId} activeTab={API_TABS.SETUP.name}>
                            <SetupController/>
                        </TabsStructure>
                    )}
                />

                <Route
                    path={`/${API_TABS.PRICING.name}`}
                    element={(
                        <TabsStructure accountId={accountId} activeTab={API_TABS.PRICING.name}>
                            <PricingController/>
                        </TabsStructure>
                    )}
                />

                <Route
                    path={`/${API_TABS.ALERTS.name}`}
                    element={(
                        <TabsStructure accountId={accountId} activeTab={API_TABS.ALERTS.name}>
                            <AlertsController accountId={accountId}/>
                        </TabsStructure>
                    )}
                />

                <Route
                    path={`/${API_TABS.LIMITS.name}`}
                    element={(
                        <TabsStructure accountId={accountId} activeTab={API_TABS.LIMITS.name}>
                            <LimitsTab accountId={accountId}/>
                        </TabsStructure>
                    )}
                />

                <Route
                    path={`/${API_TABS.CALLS.name}/*`}
                    element={(
                        <TabsStructure accountId={accountId} activeTab={API_TABS.CALLS.name}>
                            <CallsTab accountId={accountId}/>
                        </TabsStructure>
                    )}
                />

                <Route
                    path={`/${API_TABS.RELEASE_NOTES.name}/`}
                    element={(
                        <TabsStructure accountId={accountId} activeTab={API_TABS.RELEASE_NOTES.name}>
                            <ReleaseNotesController/>
                        </TabsStructure>
                    )}
                />

                <Route
                    path="*"
                    element={
                        <Navigate to={`/profile/account/${accountId}/api/${API_TABS.SETUP.name}`} replace={true}/>
                    }
                />
            </Routes>
        </ErrorBoundary>
    );
};
